<template>
  <span v-if="showCircle" class="grid h-5 w-5 shrink-0 place-items-center rounded-full border-2 transition-colors"
    :class="checked ? 'border-primary' : 'border-border'">
    <span v-if="checked" class="h-2.5 w-2.5 rounded-full bg-primary" />
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    checked?: boolean
    showCircle?: boolean
  }>(),
  {
    showCircle: true,
  }
)
</script>